const EMPTY_FILTRO = (caixa) => {
  return {
    campoSimples: '',
    pagina: 0,
    tamanhoPagina: 15,
    caixa: caixa,
    ordem: ''
  }
}

export default EMPTY_FILTRO



// WEBPACK FOOTER //
// ./src/libs/models/filtro/emptyFiltro.js